export const SERVICES = [
  {
    id: "permanent",
    eyebrow: "Long-term talent",
    title: "Permanent recruitment",
    desc: "Find specialists for ongoing roles, with role briefing, candidate sourcing, assessment and interview coordination.",
    meta: "Permanent positions · Specialist hires",
    cta: "Discuss a permanent hire",
  },
  {
    id: "contract",
    eyebrow: "Flexible capacity",
    title: "Contract staffing",
    desc: "Engage skilled professionals for fixed-term needs, project workloads and business-as-usual support.",
    meta: "Project resources · Contract roles",
    cta: "Find contract talent",
  },
  {
    id: "contingent",
    eyebrow: "Workforce support",
    title: "Contingent workforce & labour hire",
    desc: "Support worker placements with onboarding, account management, host coordination and ongoing engagement.",
    meta: "Placement support · Worker check-ins",
    cta: "Discuss workforce requirements",
  },
  {
    id: "network",
    eyebrow: "Infrastructure talent",
    title: "ICT network & equipment",
    desc: "Recruit professionals for network engineering, infrastructure support, end-user computing and equipment environments.",
    meta: "Network engineers · Infrastructure specialists",
    cta: "Hire infrastructure specialists",
  },
  {
    id: "management",
    eyebrow: "Technology leadership",
    title: "ICT management & support",
    desc: "Find project managers, cybersecurity professionals and technology operations specialists for your organisation.",
    meta: "ICT management · Security · Support",
    cta: "Find technology professionals",
  },
  {
    id: "systems",
    eyebrow: "Software & data talent",
    title: "Applications, data & systems",
    desc: "Source developers, test professionals, application specialists, data engineers and DevOps talent.",
    meta: "Software · QA · Data · DevOps",
    cta: "Hire software and data talent",
  },
];

export const CLIENTS = [
  { name: "ING Bank", logo: "/clients/ing.png" },
  { name: "IAG Insurance", logo: "/clients/iag.png" },
  { name: "Chartered Accountants ANZ", logo: "/clients/chartered-accountants.png" },
  { name: "Ampol", logo: "/clients/ampol.png" },
  { name: "Coates Hire", logo: "/clients/coates-hire.png" },
  { name: "Perpetual", logo: "/clients/perpetual.png" },
  { name: "NSW Parliament", logo: "/clients/nsw-parliament.png" },
  { name: "Pepper Money", logo: "/clients/pepper-money.png" },
];

export const SECTORS = [
  "Banking & insurance",
  "Healthcare",
  "Government",
  "Retail",
  "Utilities",
  "Education",
  "Not-for-profit",
];

export const MINI_STEPS = [
  { num: "01", title: "Your workforce needs.", desc: "Understand the role. Clarify the requirements." },
  { num: "02", title: "The right candidates.", desc: "Source, assess and present relevant talent." },
  { num: "03", title: "Supported placements.", desc: "Onboarding. Account management. Check-ins." },
];

export const PROCESS_STEPS = [
  {
    num: "01",
    title: "Brief the role",
    desc: "Confirm duties, essential skills, location, engagement type, working arrangements and reporting lines.",
  },
  {
    num: "02",
    title: "Source & assess",
    desc: "Identify candidates, assess relevant experience and coordinate interviews and agreed screening.",
  },
  {
    num: "03",
    title: "Place & onboard",
    desc: "Agree engagement terms, coordinate onboarding and confirm worker and host induction requirements.",
  },
  {
    num: "04",
    title: "Support & monitor",
    desc: "Maintain account management, worker check-ins, host feedback and escalation pathways.",
  },
];

export const PILLARS = [
  {
    title: "A role-led recruitment approach",
    desc: "Candidate sourcing and assessment shaped around the role, essential skills and your operating environment.",
  },
  {
    title: "Placement and host coordination",
    desc: "Clear duties, onboarding arrangements, reporting lines and communication between worker, recruiter and host.",
  },
  {
    title: "Worker safety and support",
    desc: "Our WHS framework addresses pre-placement assessment, inductions, worker check-ins, incident reporting and consultation with host organisations.",
  },
];

export const TICKER = [
  "Permanent recruitment",
  "Contract staffing",
  "Contingent workforce",
  "ICT specialists",
  "Sydney / ANZ",
];

export const OFFICE = {
  email: "contact@bmptechone.com",
  phoneAU: "+61 2 8067 8518",
  phoneNZ: "+64 9 355 3285",
  address: ["Level 24, Three International Towers", "300 Barangaroo Avenue, Sydney NSW 2000"],
  mapUrl: "https://maps.google.com/?q=300+Barangaroo+Avenue+Sydney+NSW+2000",
};
